import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/** Sends already-logged-in users to the app home (/app). */
export function useRedirectIfAuthenticated(enabled = true): void {
  const { status } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (status === 'authenticated') {
      navigate('/app', { replace: true });
    }
  }, [enabled, status, navigate]);
}
